// extracted by mini-css-extract-plugin
module.exports = {"ActiveQuiz":"ActiveQuiz_ActiveQuiz__2KK1S","Question":"ActiveQuiz_Question__1G1Hh"};